module.exports = __webpack_public_path__ + "static/media/img19.2f319bc3.jpg";